module.exports = __webpack_public_path__ + "media/images/pic/anime/romper-99711ec569181fdb062ce5e3ccee71e2.svg";